module.exports = "https://product-cdn.sandbox.surfline.com/kbyg/_next/static/images/all-stories-tile-mobile-2f62d8f7db16365bc94087971d977514.png";